import { rage } from '~/rage';
import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBackground, StyledShadow } from './Background.styled';

const Background = () => {
	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.Default} />
			)}
			<StyledBackground />
			<StyledShadow />
		</Fragment>
	);
};
export { Background };
